import React, { Component } from "react";
import {Link} from "react-router-dom";
import DatePicker from 'react-date-picker';
import Select from "react-select";

import './LeadDetails.scss';
import MyContext from '../MyContext.jsx';
import {epochToDate} from '../../assets/js/handy.mjs';

class LeadDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      purposes : [],
      purpose : {},
      complaint : '',
      activity : '',
      outstanding : 0,
      exe_schedule : {},
      enquiry_list : [],
      selectedEnquiry : '',
      google_forms : []
    }
    this.formChange = this.formChange.bind(this);
    this.LinkGenerate = this.LinkGenerate.bind(this);
    this.getScheduleRouteDetails = this.getScheduleRouteDetails.bind(this);
  }

  componentDidMount(){   
    this.context.loading(1);
    var obj_this = this;
    var location_coordinates = obj_this.context.location;
    if(typeof geo !== 'undefined'){
      if (location_coordinates.latitude == null || location_coordinates == "undefined"){
        alert("Unable to fetch Location");
        obj_this.props.history.replace("/dayplan");
        return;
      }
      geo.getLocation(function(location){
        if(location && location.latitude) {
            location_coordinates = location;
            obj_this.context.setLocation(location);
            obj_this.getScheduleRouteDetails(location);
        } else {
            obj_this.getScheduleRouteDetails(location_coordinates);
        }
      });
    }
    else{
      obj_this.getScheduleRouteDetails(location_coordinates);
    }
  }

  getScheduleRouteDetails(location_coordinates){
    var obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/getScheduleRouteDetails`;
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid,
        exe_followup_detail_id : this.props.match.params.lead_id,
        edit_exe_followup_detail_id : this.props.match.params.edit_lead_id,
        customer_type : 'L',
        latitude : location_coordinates?.latitude,
        longitude : location_coordinates?.longitude,
      },
      type : "POST"
    }).done(function(return_data){
      // console.log(return_data);
      if(return_data.status == "success"){
        obj_this.setState({
          purposes : return_data.purposes,
          outstanding : return_data.outstanding,
          sales : return_data.sales,
          exe_schedule : return_data.exe_schedule,
          purpose : return_data.purpose,
          complaint : return_data.exe_schedule.complaint??'',
          activity : return_data.exe_schedule.activity??'',
          address : return_data.exe_schedule.location??'',
          enquiry_list : return_data.exe_schedule.enquiry_list,
          selectedEnquiry : parseInt(return_data.exe_schedule?.enquiry),
          google_forms : return_data.google_forms??[]
        });
        if(!return_data.purpose){
          let purpose = obj_this.props.location.state && obj_this.props.location.state.purposeOfVisit
          // console.log(purpose);
          obj_this.setState({
            purpose : purpose
          })
        }
        
        obj_this.context.loading(0);
      }else if(return_data.status ==  "already" ){
        alert("Schedule already created.");
        obj_this.context.loading(0);
        obj_this.props.history.replace("/dayplan");
       
      }
      else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      alert("Network error");
    }); 
  }

  purposeChange(option) {
    this.setState({
      purpose: option
    });
  }
  handleRadioChange = (selectedEnquiryId) => {
    this.setState({ selectedEnquiry: selectedEnquiryId });
    // console.log(selectedEnquiryId);
  };

  LinkGenerate = (leadLink) =>{
    if(window.cordova)
      var ref = cordova.InAppBrowser.open(leadLink, '_system');
    else{
      window.open(leadLink, '_blank');
    }
  }

  formChange(e){
    this.setState({
      [e.target.name] : e.target.value
    });
  }

  formSubmit(e){
    e.preventDefault();
    if(this.state.purpose==null){
        this.refs.focus();
        return;
    }

    var obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/saveScheduleRouteDetails`;
    this.context.loading(1);
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid,
        schedule_id  : this.state.exe_schedule.id,
        route_id : this.props.match.params.sched_id,
        purpose : this.state.purpose.value,
        complaint : this.state.complaint,
        activity : this.state.activity,
        outstanding : this.state.outstanding,
        sales : this.state.sales,
        edit_schedule_id : this.props.match.params.edit_sched_id,
        selectedEnquiry : this.state.selectedEnquiry??null
      },
      type : "POST"
    }).done(function(return_data){
      // console.log(return_data);
      // return;
      if(return_data.status == "success"){
        alert("Schedule details updated");
        obj_this.props.history.replace('/dayplan');
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      alert("Network error");
    });
  }

  render(){

  return (
    <MyContext.Consumer>
      {context => (
        <div className="lead_details_page_container">
          <div className="page_header">
            
            <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> Lead Details</div>
          </div>
          <div className="customer_details">
            <div className="customer_name">{this.state.exe_schedule.customer_name}</div>
          </div> 
          <form className="schedule_form"
            onSubmit={e => this.formSubmit(e)}
          >
            <div className="schedule_details_container blocks">
              <div className="input_label">Purpose of visit</div>
              <Select 
                className="purposes" 
                ref={r => {
                  this.refs = r;
                }}
                placeholder={""}
                options= {this.state.purposes}
                value={this.state.purpose}
                onChange={e => this.purposeChange(e)}
                required
              />
 
              {/* <div className="input_label">Complaint if any</div>
              <input className="complaint input custom_input"
                type="text"
                name="complaint"
                value={this.state.complaint}
                onChange={this.formChange}
                autoComplete="off"
              /> */}
              {this.state.exe_schedule?.customer_type == "L" && this.state.google_forms?.length > 0 ?
                <div className="schedule_details_container blocks">
                <div className="input_label">
                  Data Collection
                </div>
                <div className="leads_enquiry_list_container">
                  {this.state.google_forms?.map((item, idx) => (
                    item.link?
                    <div className="lead_item" key={idx} onClick={() => this.LinkGenerate(item.link)}>
                      <div className="lead_item_content">
                        <div className="lead_item_name">{item.name}</div>
                        <div className="lead_item_link" > 
                          <i className="fa fa-arrow-right"></i>
                        </div> 
                      </div>
                    </div>:<div className="lead_item lead_item_content">Link Not Updated - {item.name}</div>
                  ))}
                </div>
              </div>: ''}
              {this.state.exe_schedule?.customer_type == "L" && this.state.exe_schedule?.enquiry_list?.length > 0 ?
                <div className="schedule_details_container blocks">

                  <div className="input_label">
                    Enquiry List
                  </div>
                  <table className="leads_enquiry_list_table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Enq No</th>
                        <th>Enq Date</th>
                        <th>Enq Status</th>
                        <th>Action</th>

                      </tr>
                    </thead>
                    <tbody>
                      {this.state.exe_schedule?.enquiry_list?.map((item, idx) => (
                        <tr key={idx}>
                          <td style={{ textAlign: "center" }}>
                            <input
                              type="radio"
                              name="selectedEnquiry"
                              className="custom_radio"
                              value={item.id}
                              checked={this.state.selectedEnquiry == item.id}
                              onChange={(e) => this.handleRadioChange(item.id)}
                            />

                          </td>
                          <td>{item.enq_no}</td>
                          <td style={{ textAlign: "center" }}>{new Date(item.enq_date).toLocaleDateString('en-GB')}</td>
                          <td style={{ textAlign: "center" }}>{item.enquiry_status}</td>
                          <td>
                            <Link to={{
                              pathname: '/leads/edit/' + item.id,
                              state: {
                                from: 'schedule',
                                schedule_id: this.state.exe_schedule.id,
                                customer_id: this.state.exe_schedule.customer_id,
                                enquiry_id: item.id,
                                purposeOfVisit: this.state.purpose
                              }
                            }} >
                              <div style={{ width: '100%', textAlign: 'center' }}>
                                <i className="fa fa-arrow-right arrow-gotobutton"></i>

                              </div>
                            </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                : ''}
              <div className="input_label">Remarks if any</div>
               <textarea className="input activity custom_input" 
                name="activity"
                value={this.state.activity}
                onChange={this.formChange}
                // required
                autoComplete="off"
              />
              {/* <div className="input_label">Location coordinates</div>
              <div className="location_container">
                <input className="complaint input custom_input"
                  type="text"
                  name="location"
                  value={this.context.location.latitude+", "+this.context.location.longitude}
                  onChange={this.formChange}
                  autoComplete="off"
                  disabled
                />
                <div className="location_button">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
              </div>
              <div>
                  <div className="input_label">Location/Address</div>
                  <div className="location_container">
                    <textarea 
                      className="location input"
                      name = "address"
                      value = {this.state.address}
                      onChange = {this.formChange}
                      disabled
                    />
                  </div>
                </div> */}
            </div>

            <button type="submit" 
              className="submit_button"
              style={{display:this.state.exe_schedule.status!='CLO'?"block":'none'}}
            >
              <i className="far fa-save"></i> {this.props.match.params.sched_id?"CHECK OUT":"CHECK OUT"}
            </button>
          </form>           
        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default LeadDetails;
LeadDetails.contextType = MyContext;
